import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fivetran = defineConnector({
  identifier: "fivetran",
  name: "Fivetran",
  tagLine: "Automated data integration and ELT",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: () => "https://api\\.fivetran\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.apiKey,
      password: app.secret.apiSecret,
    }),
  steps: [
    {
      title: "Create Fivetran API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Fivetran dashboard](https://fivetran.com/dashboard), open **Account settings → REST API Config** and create an API key and secret.",
        },
      ],
    },
    {
      title: "Enter your Fivetran credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "configuration", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.fivetran.com/v1/groups",
  },
});
